// 睡眠/接続中の表示。接続不可でもエラーにせず、業務を妨げない穏やかな見た目にする。
import type { SecretaryStatus } from '../types';

interface SleepingViewProps {
  status: SecretaryStatus;
}

export function SleepingView({ status }: SleepingViewProps) {
  const checking = status === 'checking';
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-2 p-6 text-center text-gray-500">
      <span className="text-4xl">{checking ? '⏳' : '💤'}</span>
      <p className="text-sm">
        {checking ? 'AI秘書に接続しています…' : 'AI秘書はオフラインです（サーバ未接続）'}
      </p>
    </div>
  );
}
